import { Controller } from 'stimulus';

/**
 * Drives the action picker that consolidates the row of transition
 * buttons (Mark as invoiced / Return to CSM) into a single dropdown.
 * The picker doesn't post anything itself — for each action the view
 * renders a hidden `button_to` form pre-wired with the right URL, CSRF
 * token, and `data-turbo-confirm`. `choose` records which form to fire;
 * `submit` triggers `requestSubmit()` on it, so Turbo handles the
 * confirm prompt and the POST exactly as it would for any other button.
 *
 * With `autoSubmitValue: true` (set on the row picker in the finance
 * queue) the controller fires the chosen form immediately — no separate
 * Submit button is rendered.
 */
export default class extends Controller {
  static targets = ['toggle', 'submit'];

  static values = { autoSubmit: Boolean };

  connect() {
    this.targetFormId = null;
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
  }

  choose(event) {
    event.preventDefault();
    const item = event.currentTarget;
    this.targetFormId = item.dataset.formId;
    this.toggleTarget.textContent = item.dataset.label;
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
    if (this.autoSubmitValue) this.fire();
  }

  submit(event) {
    event.preventDefault();
    this.fire();
  }

  fire() {
    if (!this.targetFormId) return;
    const form = document.getElementById(this.targetFormId);
    if (form) form.requestSubmit();
  }
}
